<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg"
            :doctorId="doctorId"></DocMsg>
    <div class="page_title">预约问诊设置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <span>医生名称</span>
          <el-input v-model="doctor_name"
                    style="width: 130px; margin: 0 10px"
                    clearable
                    @input="search"></el-input>
          <span>医生手机</span>
          <el-input v-model="doctor_phone"
                    style="width: 130px; margin: 0 10px"
                    clearable
                    @input="search"></el-input>
          <span>
            <span>是否设置问诊</span>
            <el-radio-group v-model="register_status"
                            @change="search"
                            style="margin: 0 10px 0 15px">
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="2">是</el-radio>
              <el-radio :label="1">否</el-radio>
            </el-radio-group>
          </span>
          <el-button type="info"
                     style="background-color: #eceff2; color: #747981"
                     @click="search"
                     size="medium">查询</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }">
            <el-table-column prop="doctor_name"
                             label="医生姓名">
              <template slot-scope="scope">
                <span @click="showDocMsg(scope.row.doctor_id)"
                      style="cursor:pointer">{{scope.row.doctor_name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone"
                             label="手机号"></el-table-column>
            <el-table-column prop="department_name"
                             label="科室"></el-table-column>
            <el-table-column prop="hospital"
                             label="医院名称"></el-table-column>
            <el-table-column label="最近问诊日期"
                             prop="date_time">
            </el-table-column>
            <!-- <el-table-column label="出诊时段">
              <template slot-scope="scope">
                <span v-if="scope.row.day_type == 1">上午</span>
                <span v-if="scope.row.day_type == 2">下午</span>
                <span v-if="scope.row.day_type == 3">全天</span>
              </template>
            </el-table-column> -->
            <el-table-column label="放号数"
                             prop="total_num">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text"
                           @click="setConsult(scope.row.doctor_id)"
                           :disabled="module_id_array[0] ? !module_id_array.includes('814') : false">设置</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="currentPage"
                         :page-sizes="[10, 20, 50, 100]"
                         :page-size="10"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="totalNum"
                         style="margin:20px 0"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      doctor_name: '',
      doctor_phone: '',
      register_status: 0,
      doc_msg: false,
      doctorId: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  components: {
    DocMsg
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        register_status: this.register_status
      };
      this.axios
        .post('platform/doctor/doctorRegisterSetting', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.date_time = item.date_time
                ? dayjs.unix(item.date_time).format('YYYY-MM-DD')
                : '无';
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    setConsult(doctor_id) {
      this.$router.push({
        path: 'setconsult',
        query: {
          doctor_id: doctor_id
        }
      });
    }
  },
  activated() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
</style>